import { updateLinksAttributes } from '../utils/handleAttributes';

export default function customSignup() {
  const widgetName = 'customSignup';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = customSignupOpts;

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const $emailSignup = $('.homepage .emailSignup');
      $widget.replaceWith($emailSignup);

      if (hasData) {
        updateSignupFeature(data.items, widgetName);
      } else {
        $widget.remove();
        $emailSignup.remove();
        $('.signup-wrapper').remove();
      }
    },
  });
}

function updateSignupFeature(data, idName) {
  const { Title: signupTitle, Description: signupText, URL: signupURL } = data[0];

  const containerSectionClass = 'signup-wrapper';
  const inputPlaceholder = 'Enter Email';
  const buttonLabel = 'Subscribe';

  const $container = $(`.${containerSectionClass}`);
  const $signupElement = $container.find('.emailSignup');
  const $signupTextElement = $signupElement.find('.emailSignupText');

  $signupTextElement.replaceWith(`
    <div class="signup-text">
      <div class="signup-heading">
        <h2 class="signup-title">${signupTitle}</h2>
      </div>
      ${signupText ? `<p class="signup-description">${signupText}</p>` : ''}
    </div>
  `);

  $signupElement.attr('id', idName);
  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');

  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
  $container.find('.inner-container').append($signupElement);

  if (!signupURL) {
    return;
  }

  $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${signupURL}" class="button" role="button" ${updateLinksAttributes(signupURL, signupText)}>${buttonLabel}</a>
    `);
}
